import { useQuery } from "react-query";
import { get_performance_day } from "../../../faunadb/queries/performance";

export default function usePerformanceDayDetail(client, id) {
    return useQuery(["performance_day_detail", id], () => get_performance_day(client, id), { refetchOnWindowFocus: false })
}